import { Box } from "@chakra-ui/react";

export function TagToggle({
  label,
  active,
  color,
  onClick
}: {
  label: string;
  active: boolean;
  color?: string;
  onClick: () => void;
}) {
  return (
    <Box
      as="button"
      type="button"
      px="12px"
      py="5px"
      borderRadius="6px"
      fontSize="12px"
      fontWeight="600"
      border="1.5px solid"
      borderColor={active ? (color ?? "#2F80ED") : "#CBD5E0"}
      bg={active ? (color ? `${color}18` : "#EBF4FF") : "white"}
      color={active ? (color ?? "#2F80ED") : "#718096"}
      cursor="pointer"
      onClick={onClick}
      transition="all 0.15s"
      _hover={{ borderColor: color ?? "#2F80ED", color: color ?? "#2F80ED" }}
    >
      {label}
    </Box>
  );
}
